import React, { useEffect, useState } from 'react';
import AuthAPIService from "../services/auth.api.service";
import {Box, CircularProgress, } from "@mui/material";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";

export const RegulaQRCode = ({ code }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (code) {
      setLoading(false)
    }
  }, [code]);

  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    }}>
      {loading && (
          <CircularProgress />
      )}
      {!!code && (
        <>
          <Divider sx={{marginY: '20px'}} textAlign="center">Or Login with Regula</Divider>
          <Card sx={{maxWidth: 185, mb: 4, margin: '0 auto'}}>
            <CardMedia
              component="img"
              width="164"
              height="164"
              image={code}
              alt="QR"
            />
          </Card>
        </>
      )}
    </Box>
  );
};
